export enum TranslationsStorageKeys {
    visitorLang = 'visitorLang',
}

export interface TranslationsStorage {
    getSync<T = string>(key: string): T | null;
}
